import { FC } from 'react';
import { Routes, Route } from 'react-router-dom';

import { ROUTES } from '@/route/routes.constants.ts';
import { InspectionDetails } from '@/features/inspection-details/InspectionDetails';
import { ModuleRenderer } from '@/features/inspection-details/components/module-renderer/ModuleRenderer';
import { WithAuth } from '@/features/auth/WithAuth';
import { InspectionPage } from '@/features/inspection-list/InspectionList';
import { StartInspectionPage } from '@/features/inspection-list/StartInspectionPage';
import { FactoryVerificationPage } from '@/features/inspection-list/FactoryVerificationPage';
import { PageNotFound } from '@/components/pageNotFound/pageNotFound';
import { DbInfo } from '@/components/db-info/dbInfo';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { ROLE } from '@/role.constant';
import { Forbidden } from '@/components/Forbidden/Forbidden';
import { InspectionErrorBoundary } from '@/components/error/InspectionErrorBoundary';

const AppRoutes: FC = () => {
  return (
    <WithAuth>
      <Routes>
        <Route
          path={ROUTES.INSPECTIONS}
          element={
            <ProtectedRoute requiredAnyRole={[ROLE.QC_INSPECTOR, ROLE.CARTON_INSPECTOR]}>
              <InspectionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.INSPECTION_START}
          element={
            <ProtectedRoute requiredAnyRole={[ROLE.QC_INSPECTOR, ROLE.CARTON_INSPECTOR]}>
              <StartInspectionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.INSPECTION_VERIFICATION}
          element={
            <ProtectedRoute requiredAnyRole={[ROLE.QC_INSPECTOR, ROLE.CARTON_INSPECTOR]}>
              <FactoryVerificationPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.INSPECTION_DETAILS}
          element={
            <ProtectedRoute requiredAnyRole={[ROLE.QC_INSPECTOR, ROLE.CARTON_INSPECTOR]}>
              <InspectionErrorBoundary>
                <InspectionDetails />
              </InspectionErrorBoundary>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.INSPECTION_MODULE}
          element={
            <ProtectedRoute requiredAnyRole={[ROLE.QC_INSPECTOR, ROLE.CARTON_INSPECTOR]}>
              <InspectionErrorBoundary>
                <ModuleRenderer />
              </InspectionErrorBoundary>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.TOOLING}
          element={
            <ProtectedRoute requiredAnyRole={[ROLE.QC_INSPECTOR, ROLE.CARTON_INSPECTOR]}>
              <DbInfo />
            </ProtectedRoute>
          }
        />
        <Route path={ROUTES.NOT_FOUND} element={<PageNotFound />} />
        <Route path={ROUTES.FORBIDDEN} element={<Forbidden />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </WithAuth>
  );
};

export default AppRoutes;
